import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "wouter";

import { HashtagString } from "../../stores/useHashState";
import { Button } from "../../ui/Button/Button";
import { DownloadIcon } from "../../ui/icons/DownloadIcon";
import { EnvelopeLiteIcon } from "../../ui/icons/EnvelopeLiteIcon";
import { PrinterIcon } from "../../ui/icons/PrinterIcon";
import { Calculator } from "../Calculator/Calculator";
import { customerMessageParamName } from "./LeadFormModal";

const getHref = (hash: string): string => {
  const url = new URL(window.location.href);
  const urlParam = url.toString();
  url.hash = hash;
  url.searchParams.set(customerMessageParamName, urlParam);
  return url.toString();
};

export const LeadFormButtons: FunctionComponent = () => {
  const { t } = useTranslation();
  const href = (hash: HashtagString): string => getHref?.(hash) ?? hash;

  return (
    <nav className="flex space-x-1 row-start-1 md:row-start-2 justify-end">
      <div className="hidden md:block">
        <Calculator variant="inline" />
      </div>
      <Link replace to={href("#download")}>
        <Button
          aria-label="openDownloadDialog"
          className="font-thin text-ink-2 px-2 md:px-4"
          element="a"
        >
          <DownloadIcon />
          <span className="hidden md:inline">{t("leadForm.download")}</span>
        </Button>
      </Link>
      <Link replace to={href("#email")}>
        <Button
          aria-label="openEmailDialog"
          className="font-thin text-ink-2 px-2 md:px-4"
          element="a"
        >
          <EnvelopeLiteIcon />
          <span className="hidden md:inline">{t("leadForm.email")}</span>
        </Button>
      </Link>
      <Link replace to={href("#print")}>
        <Button
          aria-label="openPrintDialog"
          className="font-thin text-ink-2 px-2 md:px-4"
          element="a"
        >
          <PrinterIcon />
          <span className="hidden md:inline">{t("leadForm.print")}</span>
        </Button>
      </Link>
    </nav>
  );
};

/**
 * @see docs/worklog/TW-874-comparison-lead-link/rfc.md
 * @see docs/worklog/TW-874-comparison-lead-link/tfc.md
 * @see docs/worklog/TW-897-sales-calculator-ring/rfc.md
 */
